export function set(state, envConfig) {
  Object.assign(state, envConfig);
}
